<template>
  <div style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
</template>
<script>
  export default {
    name: 'ShareCoupon',
  }
</script>
<script setup>
  import store from '@/store'
  import { useRoute } from 'vue-router'
  import { onMounted, getCurrentInstance } from 'vue'
  import { Toast } from 'vant'
  const route = useRoute()
  const { proxy } = getCurrentInstance()
  onMounted(() => {
    CourseSharingCheck()
  })
  const CourseSharingCheck = async () => {
    const query = route.query
    let url = await store.getters['system/getH5Url']
    url += `home/#/pagesService/share/share?formId=${query.formId}`
    if (query.channelId) {
      url += `&channelId=${query.channelId}`
    }
    if (query.nodeId) {
      url += `&nodeId=${query.nodeId}`
    }
    if (query.from) {
      url += `&from=${query.from}`
    }

    location.href = url

    return

    store.dispatch('service/CourseSharingCheck', query).then((data) => {
      const { Data } = data
      // 未购买且是公开课
      if (!Data.Owned && Data.IsOpenClass) {
        go(
          '您还未领取该课程，正跳转至领取页面',
          'Index',
          {
            query: { productId: Data.ProductId, channelId: query.channelId },
          },
          'replace'
        )
      }

      // 未购买且不是公开课
      if (!Data.Owned && !Data.IsOpenClass) {
        go(
          Data.Message,
          'CaseWjsContent',
          {
            params: { id: Data.ProductId },
          },
          'replace'
        )
      }

      // 已购买但服务未开启
      if (Data.Owned && !Data.IsStart) {
        go(Data.Message, 'Index', {})
      }

      // 已购买且服务已开启但这节课你还未开启
      if (Data.Owned && Data.IsStart && !Data.NodeMatched) {
        go(Data.Message, 'ServiceContent', { params: { id: Data.FormId } })
      }

      // 已购买且服务已开启且节点能对上
      if (Data.Owned && Data.IsStart && Data.NodeMatched) {
        go(
          Data.Message,
          'ServiceContent',
          {
            params: { id: Data.FormId },
            query: {
              nodeId: Data.NodeId,
            },
          },
          'push',
          0
        )
      }
    })
  }

  const go = (msg, name, opt, type = 'push', duration = 2000) => {
    if (msg) Toast(msg)
    setTimeout(() => {
      proxy.$go(name, opt, type)
    }, duration)
  }
</script>
